import { IRootState } from '../../../store'
import { IBurnOptionsState } from '../store/options.types'

export const getBurnsOptionsSelector = (state: IRootState): IBurnOptionsState => state.options.burnOptions
